import { map, pick } from 'lodash'

const transformToSaveLocationTypesAndLocationTypeCategoriesArgs = data =>
  map(data, (locationTypeCategory, locationTypeCategoryIndex) => ({
    ...pick(locationTypeCategory, ['id', 'name', 'isCurationEnabled']),
    position: locationTypeCategoryIndex,
    children: map(locationTypeCategory.children, (locationType, index) => ({
      ...pick(locationType, ['id', 'name', 'parentId', 'isCurationEnabled']),
      position: index,
    })),
  }))

export default transformToSaveLocationTypesAndLocationTypeCategoriesArgs
